import { api } from '@forbiz/web-kit'
import type { PostKind, PublicPostDetail, PublicPostListResponse } from '@forbiz/contracts'

/**
 * 콘텐츠 조회 (공지·이벤트·가이드). 담당자 화면에서 소식(/notices)·이용안내(/guide)로 읽는다.
 */
export const postsApi = {
  list(kinds: PostKind[]): Promise<PublicPostListResponse> {
    const q = kinds.length > 0 ? `?kinds=${kinds.join(',')}` : ''
    return api.get<PublicPostListResponse>(`/api/posts${q}`)
  },
  get(id: number): Promise<{ post: PublicPostDetail }> {
    return api.get<{ post: PublicPostDetail }>(`/api/posts/${id}`)
  },
}
